<template>
  <router-view />
</template>

<script setup lang="ts">
  // import watermark from '@/utils/lib/watermark';
  // import copyPaste from '@/utils/lib/copy-paste';

  import { operateBuriedNoToken } from '@/api/point';
  import { goBack } from '@/hooks/goBack';
  import { storage } from '@/utils';
  const { getDateTime } = goBack();

  const route = useRoute();
  const getUrlParam = (paramName: string) => {
    // 从 window.location.href 中获取查询字符串（URL 中问号及后面的部分）
    const queryString = window.location.search;
    // 如果没有查询字符串，直接返回 null
    if (!queryString) {
      return null;
    }
    // 去掉问号，获取真正的参数部分
    const params = queryString.substring(1);
    // 将参数部分按 & 分割成数组
    const paramPairs = params.split('&');
    // 遍历参数对
    for (const pair of paramPairs) {
      // 对每个参数对按 = 分割成键值对
      const [name, value] = pair.split('=');

      // 解码参数名和参数值（处理 URL 编码）
      const decodedName = decodeURIComponent(name);
      const decodedValue = decodeURIComponent(value || '');

      // 如果找到匹配的参数名，返回其值
      if (decodedName === paramName) {
        return decodedValue;
      }
    }
    // 没找到匹配的参数名，返回 null
    return null;
  };
  onMounted(() => {
    const val = getUrlParam('channelId');
    if (val) {
      storage.setItem('channelId', val, null, 2);
    }
    operateBuriedNoToken({
      currentPageCode: 'ysr100000',
      currentPageName: '系统首页',
      fromPageCode: '',
      fromPageName: '',
      logTime: getDateTime(),
      eventCode: 'JR_H5_USER_PAGE_VIEW',
      extraDataJson: JSON.stringify({
        burSystem: 1,
      }),
      appName: 'new-yousurong',
      pageFlag: (route.query.flag as string) || '',
    });
    // const { username = '', mobile = '' } = auth.getUser();
    // watermark.add({
    //   // content: username + ' ' + mobile,
    // });
    // copyPaste.disable();
  });

  onBeforeUnmount(() => {
    // watermark.remove();
    // copyPaste.enable();
  });
</script>

<style>
  #app {
    font-family: Inter, Avenir, Helvetica, Arial, sans-serif;
    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }
</style>
